import React from "react";

export default function TermsOfService() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-2">
        Terms & Conditions - Expense Tracker
      </h1>

      <p className="text-muted-foreground mb-8">Last Updated: June 2026</p>

      <div className="space-y-8 text-sm sm:text-base leading-7">
        <section>
          <h2 className="text-2xl font-semibold mb-3">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using Expense Tracker by ExpenseHut ("Service"), you
            agree to be bound by these Terms of Service. If you do not agree to
            these Terms, please do not use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">2. Eligibility</h2>
          <p>
            You must be at least 18 years old or the age of majority in your
            jurisdiction to use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">
            3. Description of Service
          </h2>
          <p>
            Expense Tracker is a personal finance and budgeting platform that
            helps users:
          </p>

          <ul className="list-disc pl-6 mt-3 space-y-1">
            <li>Track expenses and income</li>
            <li>Create budgeting groups</li>
            <li>Manage family and shared finances</li>
            <li>Import financial data</li>
            <li>Connect supported financial institutions</li>
            <li>View spending analytics and reports</li>
            <li>Monitor financial trends</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">
            4. No Financial Advice
          </h2>
          <p>
            Expense Tracker is not a bank, financial institution, accounting
            firm, tax advisor, investment advisor, or financial planner.
          </p>

          <p className="mt-3">
            Information provided through the Service is for informational
            purposes only and should not be considered financial, tax,
            accounting, legal, or investment advice.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">5. User Accounts</h2>

          <p>
            You are responsible for maintaining the security of your account and
            password. You agree not to share your account credentials with
            others.
          </p>

          <p className="mt-3">
            You are responsible for all activities that occur under your
            account.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">
            6. Financial Account Connections
          </h2>

          <p>
            The Service may allow you to connect financial institutions through
            third-party providers.
          </p>

          <p className="mt-3">
            ExpenseHut does not guarantee the accuracy, availability, or
            completeness of data supplied by third parties.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">7. Subscription Plans</h2>

          <p>
            Certain features may require a paid subscription. Subscription fees
            are billed according to the plan selected by the user.
          </p>

          <p className="mt-3">
            Subscriptions may renew automatically unless canceled before the
            renewal date.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">8. Acceptable Use</h2>

          <p>You agree not to:</p>

          <ul className="list-disc pl-6 mt-3 space-y-1">
            <li>Violate applicable laws</li>
            <li>Attempt unauthorized access to systems or data</li>
            <li>Upload malicious software</li>
            <li>Use the Service for fraudulent activities</li>
            <li>Interfere with platform operations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">9. User Data</h2>

          <p>
            You retain ownership of the financial information, expenses, income
            records, and content you upload to the Service.
          </p>

          <p className="mt-3">
            You grant ExpenseHut permission to store, process, and display such
            information solely for providing the Service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">10. Privacy</h2>

          <p>Your use of the Service is also governed by our Privacy Policy.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">
            11. Service Availability
          </h2>

          <p>
            We strive to provide a reliable service but do not guarantee
            uninterrupted availability, accuracy, or error-free operation.
          </p>

          <p className="mt-3">
            Features may be modified, suspended, or discontinued at any time.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">
            12. Disclaimer of Warranties
          </h2>

          <p>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
            WARRANTIES OF ANY KIND.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">
            13. Limitation of Liability
          </h2>

          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, EXPENSEHUT SHALL NOT BE
            LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
            PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">14. Termination</h2>

          <p>
            We may suspend or terminate accounts that violate these Terms or
            engage in fraudulent, abusive, or unlawful activities.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">15. Governing Law</h2>

          <p>
            These Terms shall be governed by the laws of the State of Texas,
            United States.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">16. Contact Us</h2>

          <p>
            ExpenseHut LLC
            <br />
            Austin, Texas, USA
            <br />
            help@expensehut.com
          </p>
        </section>
      </div>
    </div>
  );
}
